<div class="tt-w-vc-pinboard">
  <tt-masonry-layout v-if="items.length > 0"
                     ref="layout"
                     :items="items"
                     :breakpointsConfig="pinboardConfig.breakpointsConfig" 
                     :useProgressiveLoading="useProgressiveLoading"
                     @loadMore="fetchData"
                     @doneLoading="doneLoading"
                     :class="'tt-w-vc-pinboard__list'">
    <template v-slot:default="{item, index, tileWidth}">
      <tt-pinboard-item @click.prevent="openModal($event, index)"
                        :media="item" 
                        :key="item.id"
                        :tileWidth="tileWidth"
                        :hoverTitleMaxLength="pinboardConfig.hoverTitleMaxLength"
                        :maxCaptionLength="pinboardConfig.maxCaptionLength"
                        :showCaption="pinboardConfig.showCaption"
                        :showDatestamp="pinboardConfig.showDatestamp"
                        :showReviewStars="pinboardConfig.showReviewStars"
                        :userNameMaxLength="pinboardConfig.userNameMaxLength"></tt-pinboard-item>
    </template>                      
  </tt-masonry-layout>
  <div v-if="displayShowMoreWrapper" class="tt-w-vc-pinboard__show-more-wrapper">
    <tt-button v-show="displayShowMoreButton" type="primary" @click="showMore" class="tt-w-vc-pinboard__show-more" v-html="$msg('vcPinboard.showMore')"></tt-button>
    <div v-show="isLoading" class="tt-o-spinner tt-w-vc-pinboard__loading"></div>
  </div>
</div>
